import { useEffect, useState } from "react";
import { BlockWithError, BlockWithLoading } from "@/ui";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { editRobot, getRobot, selectActiveRobotId, selectActiveRobotVersion, selectEditingRobot, selectRobot } from "@/store/ses/sesRobotSlice";
import { useAccessRight } from "@/hooks";
import { SES } from "@/constants/accessRights";
import { RequestStatus, ResponseStatus } from "@/types/statusTypes";
import { Calendar } from "@/components";
import styles from "./RobotCalendar.module.scss";

const RobotCalendar = (): JSX.Element => {
	const [changeFlg, setChangeFlg] = useState<boolean>(false); // флаг, уведомляющий об изменении данных и возможности сохранить эти изменения

	const dispatch = useAppDispatch();
	const activeRobotId = useAppSelector(selectActiveRobotId); // store - id активного робота
	const robotInfo = useAppSelector(selectRobot); // store - информация о роботе
	const editingRobot = useAppSelector(selectEditingRobot); // store - статус изменения данных робота
	const activeRobotVersion = useAppSelector(selectActiveRobotVersion); // store - версия активного робота

	const isAccess = useAccessRight(); // hook для проверки прав доступа

	// следим за получением данных робота
	useEffect(() => {
		// если есть данные
		if (robotInfo.data) {
			setChangeFlg(false); // сбрасываем флаг возможности сохранения
		}
	}, [robotInfo.data]);

	// следим за статусом изменения робота
	useEffect(() => {
		// если изменение данных робота прошло успешно
		if (editingRobot.status === RequestStatus.IDLE && editingRobot.error === ResponseStatus.SUCCESS && editingRobot.message !== "") {
			setChangeFlg(false); // сбрасываем флаг о несохраненных данных
		}
	}, [editingRobot]);

	// обработчик сохранения данных робота
	const editRobotHandler = (holidays: string[]): void => {
		robotInfo.data &&
			dispatch(
				editRobot({
					robotId: robotInfo.data.id,
					data: {
						holidays,
					},
				})
			); // изменяем данные робота
	};

	return (
		<div className={styles.configRobot}>
			{/* загрузка настроек робота */}
			{robotInfo.status === RequestStatus.LOADING && <BlockWithLoading />}

			{/* ошибка получения настроек робота */}
			{robotInfo.status === RequestStatus.FAILED && (
				<BlockWithError
					message={robotInfo.message}
					updateHandler={() => {
						isAccess(SES.ROBOT_GET) && activeRobotId && dispatch(getRobot(activeRobotId)); // получаем инфо о роботе;
					}}
				/>
			)}

			{/* настройки робота */}
			{robotInfo.status === RequestStatus.IDLE && robotInfo.data && (
				<Calendar
					isDisabled={!isAccess(SES.ROBOT_EDIT)}
					isHaveRights={activeRobotVersion === "draft"}
					changeFlg={changeFlg}
					setChangeFlg={setChangeFlg}
					saveChangesHandler={editRobotHandler}
					initialHolidayList={robotInfo.data.holidays}
				/>
			)}
		</div>
	);
};

export default RobotCalendar;
